import Icon from "@ant-design/icons"
import { ReactComponent as ItalyFlag } from "./italy.svg"

const ItalyFlagIcon = (props: any) => <Icon component={ItalyFlag} {...props} />

export default ItalyFlagIcon
